export const ALL = 'ALL';
export const SOME = 'SOME';
export const NONE = 'NONE';
export const AIR_EQUIPMENT_CODE = 'AIR';
export const TRAIN_EQUIPMENT_CODE = 'TRN';
export const BUS_EQUIPMENT_CODE = 'BUS';
